import { faqs, brandInfo } from "@/mocks/home";

export default function StructuredData() {
  const siteUrl = "https://xuanfei.com.cn/";

  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${siteUrl}#organization`,
        name: brandInfo.name,
        url: siteUrl,
        email: brandInfo.email,
        description:
          "微光爆料是一个面向普通网友的爆料投稿信息指引平台，讲清投稿后多久发布、是否保护投稿人、稿费结算规则与投稿格式要求。",
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}#website`,
        url: siteUrl,
        name: brandInfo.name,
        inLanguage: "zh-CN",
        publisher: { "@id": `${siteUrl}#organization` },
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}#webpage`,
        url: siteUrl,
        name: "爆料投稿全指南｜审核时长、隐私保护、稿费结算规则",
        description:
          "投稿后多久发布、是否保护投稿人、稿费怎么结算、格式怎么写，投稿前一次看懂，避免踩坑顺利过审。",
        isPartOf: { "@id": `${siteUrl}#website` },
        inLanguage: "zh-CN",
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${siteUrl}#breadcrumb`,
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "首页",
            item: siteUrl,
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "爆料投稿指南",
            item: `${siteUrl}#top`,
          },
        ],
      },
      {
        "@type": "FAQPage",
        "@id": `${siteUrl}#faq`,
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a,
          },
        })),
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(graph) }}
    />
  );
}